<template>
    <div class="cart-page">
      <!-- 主内容区 -->
      <el-card class="cart-container">
        <!-- 头部 -->
        <div slot="header" class="cart-header">
          <el-page-header @back="back" content="返回"></el-page-header>
          <h2 class="cart-title">我的购物车</h2>
        </div>
  
        <!-- 商品列表 -->
        <div class="goods-list">
          <div class="list-header">
            <el-checkbox v-model="allSelected" @change="toggleAll">全选</el-checkbox>
            <span class="header-item product-info">商品信息</span>
            <span class="header-item">单价</span>
            <span class="header-item">操作</span>
          </div>
  
          <div v-for="(item, index) in cartList" :key="item.id" class="cart-item">
            <el-checkbox v-model="item.selected"></el-checkbox>
            <div class="product-info">
              <el-image 
                :src="item.images[0]" 
                class="goods-image"
                fit="cover"></el-image>
              <div class="goods-desc">
                <h4 class="goods-title">{{ item.name }}</h4>
                <el-tag type="info" size="mini">编号：{{ item.id }}</el-tag>
              </div>
            </div>
            <div class="price">¥{{ item.price.toFixed(2) }}</div>
            <div class="actions">
              <el-button 
                type="danger" 
                icon="el-icon-delete" 
                circle
                size="mini"
                @click="removeItem(index)"></el-button>
            </div>
          </div>
        </div>
  
        <!-- 结算栏 -->
        <div class="checkout-bar">
          <div class="total-info">
            已选 <span class="highlight">{{ selectedCount }}</span> 件商品，
            合计：<span class="total-price">¥{{ totalPrice.toFixed(2) }}</span>
          </div>
          <el-button 
            type="primary" 
            size="medium"
            :disabled="selectedCount === 0"
            @click="showCheckoutDialog">
            去结算（{{ selectedCount }}）
          </el-button>
        </div>
      </el-card>
  
      <!-- 结算弹窗 -->
      <el-dialog :visible.sync="showDialog" title="确认订单" width="600px">
        <div class="address-section">
          <h4>选择收货地址</h4>
          <el-radio-group v-model="selectedAddress">
            <div v-for="addr in addressList" :key="addr.id" class="address-item">
              <el-radio :label="addr">
                <div class="address-info">
                  <span class="receiver">{{ addr.name }}</span>
                  <span class="phone">{{ addr.phone }}</span>
                  <div class="detail-address">{{ addr.address }}</div>
                </div>
              </el-radio>
            </div>
          </el-radio-group>
          <el-button type="text" @click="showAddressForm = true">+ 新增地址</el-button>
        </div>
        
        <div class="payment-section">
          <h4>支付方式</h4>
          <el-radio-group v-model="paymentType">
            <el-radio label="wechat">
              <i class="iconfont icon-wechat"></i> 微信支付
            </el-radio>
            <el-radio label="alipay">
              <i class="iconfont icon-alipay"></i> 支付宝
            </el-radio>
          </el-radio-group>
        </div>
  
        <div slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">取消</el-button>
          <el-button type="primary" @click="handlePayment">立即支付</el-button>
        </div>
      </el-dialog>
  
      <!-- 新增地址弹窗 -->
      <el-dialog 
        title="新增收货地址" 
        :visible.sync="showAddressForm"
        width="500px">
        <el-form :model="newAddress" :rules="addressRules" ref="addressForm">
          <el-form-item label="收货人" prop="name">
            <el-input v-model="newAddress.name"></el-input>
          </el-form-item>
          
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="newAddress.phone"></el-input>
          </el-form-item>
  
          <el-form-item label="所在地区" prop="region">
            <el-cascader
              v-model="newAddress.region"
              :options="regionOptions"
              placeholder="请选择省/市/区"
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
  
          <el-form-item label="详细地址" prop="detail">
            <el-input 
              v-model="newAddress.detail"
              placeholder="街道、楼牌号等"></el-input>
          </el-form-item>
        </el-form>
  
        <div slot="footer">
          <el-button @click="showAddressForm = false">取消</el-button>
          <el-button type="primary" @click="saveAddress">保存</el-button>
        </div>
      </el-dialog>
  
      <!-- 支付二维码弹窗 -->
      <el-dialog :visible.sync="showPaymentDialog" title="请扫码支付" width="300px">
        <div class="qrcode-container">
          <img :src="paymentQR" class="qrcode-image">
          <p class="tip">请使用{{ paymentType === 'wechat' ? '微信' : '支付宝' }}扫码支付</p>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import provinces from '../assets/chinaDivision/provinces.js'
  import cities from '../assets/chinaDivision/cities.js'
  import areas from '../assets/chinaDivision/areas.js'
  
  export default {
    data() {
      return {
        cartList: [
          {
            id: 1,
            images: ["https://picsum.photos/100/100?random=1"],
            name: "皇家狗粮",
            price: 199,
            selected: true
          },
          {
            id: 2,
            images: ["https://picsum.photos/100/100?random=2"],
            name: "猫罐头",
            price: 29,
            selected: false
          },
          {
            id: 3,
            images: ["https://picsum.photos/100/100?random=3"],
            name: "驱虫剂",
            price: 45,
            selected: true
          }
        ],
        addressList: [
          {
            id: 1001,
            name: "张三",
            phone: "13800138000",
            address: "北京市朝阳区光华路8号"
          },
          {
            id: 1002,
            name: "李四（公司）",
            phone: "13900139000",
            address: "上海市浦东新区陆家嘴环路100号"
          }
        ],
        showDialog: false,
        showPaymentDialog: false,
        showAddressForm: false,
        allSelected: false,
        selectedAddress: null,
        paymentType: 'wechat',
        paymentQR: 'https://picsum.photos/200/200?random=4',
        newAddress: {
          name: '',
          phone: '',
          region: [],
          detail: ''
        },
        regionOptions: [],
        addressRules: {
          name: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }
          ],
          region: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
          detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
        }
      }
    },
    computed: {
      totalPrice() {
        return this.cartList
          .filter(item => item.selected)
          .reduce((sum, item) => sum + item.price, 0)
      },
      selectedCount() {
        return this.cartList.filter(item => item.selected).length
      }
    },
    created() {
      this.initRegionData()
    },
    methods: {
      initRegionData() {
        this.regionOptions = provinces.map(province => ({
          value: province.code,
          label: province.name,
          children: cities[province.code]?.map(city => ({
            value: city.code,
            label: city.name,
            children: areas[city.code]?.map(area => ({
              value: area.code,
              label: area.name
            }))
          }))
        }))
      },
      saveAddress() {
        this.$refs.addressForm.validate(valid => {
          if (valid) {
            const [provinceCode, cityCode, areaCode] = this.newAddress.region
            const province = provinces.find(p => p.code === provinceCode).name
            const city = cities[provinceCode].find(c => c.code === cityCode).name
            const area = areas[cityCode].find(a => a.code === areaCode).name
  
            this.addressList.push({
              id: Date.now(),
              name: this.newAddress.name,
              phone: this.newAddress.phone,
              address: `${province} ${city} ${area} ${this.newAddress.detail}`
            })
  
            this.showAddressForm = false
            this.$message.success('地址添加成功')
            this.$refs.addressForm.resetFields()
          }
        })
      },
      toggleAll() {
        this.cartList.forEach(item => item.selected = this.allSelected)
      },
      removeItem(index) {
        this.cartList.splice(index, 1)
        this.$message.success('商品已移除')
      },
      back() {
        this.$router.go(-1)
      },
      showCheckoutDialog() {
        if (this.selectedCount === 0) {
          this.$message.warning('请先选择商品')
          return
        }
        this.showDialog = true
      },
      async handlePayment() {
        if (!this.selectedAddress) {
          this.$message.warning('请选择收货地址')
          return
        }
  
        try {
          this.paymentQR = this.paymentType === 'wechat' 
            ? 'http://www.wjyzlj.cn/bsPic/wechat.jpg' 
            : 'http://www.wjyzlj.cn/bsPic/wechat.jpg'
          
          this.showPaymentDialog = true
          this.showDialog = false
          this.startPaymentCheck()
        } catch (error) {
          this.$message.error('支付请求失败')
        }
      },
      startPaymentCheck() {
        let count = 0
        const timer = setInterval(() => {
          if (count++ >= 5) {
            clearInterval(timer)
            this.$message.error('支付超时')
            this.showPaymentDialog = false
          }
        }, 3000)
      }
    }
  }
  </script>
  
  <style scoped>
  .cart-page {
    max-width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
  }
  
  .cart-container {
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0,0,0,.1);
  }
  
  .cart-header {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .cart-title {
    margin: 0;
    color: #303133;
  }
  
  .list-header {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
    font-size: 14px;
  }
  
  .header-item {
    flex: 1;
    text-align: center;
    min-width: 100px;
  }
  
  .product-info {
    flex: 2;
    padding-left: 20px;
  }
  
  .cart-item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #ebeef5;
  }
  
  .goods-image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    margin-right: 15px;
  }
  
  .goods-desc {
    flex: 1;
  }
  
  .goods-title {
    margin: 0 0 8px 0;
    color: #303133;
    font-size: 16px;
  }
  
  .price {
    color: #f56c6c;
    font-weight: bold;
  }
  
  .checkout-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    margin-top: 20px;
  }
  
  .total-info {
    font-size: 16px;
    color: #606266;
  }
  
  .highlight {
    color: #409eff;
    font-weight: bold;
  }
  
  .total-price {
    color: #f56c6c;
    font-size: 24px;
    margin-left: 10px;
  }
  
  .address-item {
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }
  
  .address-info {
    margin-left: 10px;
  }
  
  .receiver {
    font-weight: bold;
    margin-right: 15px;
  }
  
  .detail-address {
    color: #909399;
    margin-top: 5px;
  }
  
  .qrcode-container {
    text-align: center;
  }
  
  .qrcode-image {
    width: 200px;
    height: 200px;
    margin: 0 auto;
  }
  
  .tip {
    color: #909399;
    margin-top: 10px;
  }
  
  .iconfont {
    margin-right: 5px;
    font-size: 24px;
  }
  
  .icon-wechat {
    color: #09bb07;
  }
  
  .icon-alipay {
    color: #1677ff;
  }
  
  /* 新增地址表单样式 */
  .el-cascader-menu {
    height: 200px;
  }
  </style>